import { getStore, setStore, removeStore } from './localStorage';
export function getLanguage() {
  return getStore("LANGUAGE_QAI");
}
export function setLanguage(language) {
    setStore("LANGUAGE_QAI",language);
}